'use client';

import React from 'react';
import Link from 'next/link';
import { cn } from '@/lib/utils/cn';
import type { LandingPage } from '@/types/landingPage';
import { DynamicIcon } from '@/components/ui/shared/dynamic-icon';

interface Link {
  title?: string;
  icon?: string | null;
  url: string;
  id?: string | null;
}
interface SocialLinkProps {
  link: Link;
}

const SocialLink: React.FC<SocialLinkProps> = ({ link }) => {
  const title = link.title || 'Social Link';

  return (
    <div className={cn('social-link')}>
      <Link
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="block py-2 px-3 bg-zinc-950 hover:bg-zinc-700 transition-all duration-200
                  rounded-sm cursor-pointer group"
        aria-label={`${title}`}
      >
        <div className="flex items-center justify-between gap-2 mb-1">
          <div className="uppercase text-[12px] font-bold text-zinc-500 group-hover:text-white transition-colors">
            {title}
          </div>
          {link.icon && (
            <DynamicIcon
              icon={link.icon}
              className="w-4 h-4 text-zinc-500 group-hover:text-white transition-colors"
            />
          )}
        </div>
        <div className="text-[10px] text-white group-hover:text-white transition-colors">{title}</div>
      </Link>
    </div>
  );
};

export function SocialLinks({ contactData }: { contactData: LandingPage }) {
  /* 
  const socialLinks = [
    { platform: 'EMAIL', username: 'NETORKHAN.ART', href: 'mailto:info@orkhan.art' },
    { platform: 'INSTA', username: '@ORKHAN.ART', href: 'https://instagram.com/orkhan.art' },
    { platform: 'FARCASTER', username: '@ORKHAN.ART', href: 'https://farcaster.xyz/orkhan.art' },
    { platform: 'YOUTUBE', username: '@ORKHAN.ART', href: 'https://youtube.com/@orkhan.art' },
    { platform: 'DISCORD', username: '@ORKHAN.ART', href: 'https://discord.gg/orkhan' },
    { platform: 'MIRROR', username: '@ORKHAN.ART', href: 'https://mirror.xyz/orkhan.art' },
    { platform: 'PINTEREST', username: '@ORKHAN.ART', href: 'https://pinterest.com/orkhan.art' },
    { platform: 'LINKEDIN', username: '@ORKHAN.ART', href: 'https://linkedin.com/in/orkhan-art' },
    { platform: 'BEHANCE', username: '@ORKHAN.ART', href: 'https://behance.net/orkhan-art' },
    { platform: 'X', username: '@ORKHAN', href: 'https://x.com/orkhan' },
    { platform: 'RODEO', username: '@ORKHAN.ART', href: 'https://rodeo.xyz/orkhan' },
    { platform: 'VIMEO', username: '@ORKHAN.ART', href: 'https://vimeo.com/orkhan' },
  ];
 */

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {contactData.socialLinks?.map(link => <SocialLink key={link.id} link={link} />)}
    </div>
  );
}
